import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { authService } from "@/services/AuthService";
import Header from "@/components/Header.vue";
export default defineComponent({
    name: "PasswordRecovery",
    components: {
        Header,
    },
    setup() {
        const email = ref("");
        const loading = ref(false);
        const message = ref(null);
        const messageType = ref(""); // 'error' o 'success'
        const router = useRouter();
        // Función para manejar la recuperación de contraseña
        const handlePasswordRecovery = async () => {
            loading.value = true;
            message.value = null;
            messageType.value = "";
            try {
                // Llamada al servicio de autenticación para enviar el correo
                const response = await authService.recoverPassword(email.value);
                console.log(response);
                if (response.exito) {
                    message.value =
                        "Se han enviado instrucciones a tu correo para restablecer la contraseña.";
                    messageType.value = "success";
                    email.value = ""; // Limpiar campo de correo
                }
            }
            catch (error) {
                console.log("error", error);
                // Verificar si el error contiene la propiedad 'errores'
                if (error && error.message) {
                    message.value = error.message; // Mostrar el mensaje de error específico
                }
                else {
                    message.value =
                        "Hubo un error al enviar el correo. Intenta de nuevo."; // Mensaje por defecto
                }
                messageType.value = "error";
                messageType.value = "error";
            }
            finally {
                loading.value = false;
            }
        };
        return {
            email,
            loading,
            message,
            messageType,
            handlePasswordRecovery,
        };
    },
});
